import React, { useEffect, useState } from "react";
import { IPagination } from "../../../types/customTypes";
import { ITableOffer, MIQuerySearchParams } from "../../../types/financeTypes";
import MTable from "../../../components/finance/MTable";
import { GridColDef } from "@mui/x-data-grid";
import { Box, Grid, Typography } from "@mui/material";
import { useGetAllOffersForFinanceQuery } from "../../../api/offerApi";
import { defaultPaginationModel } from "../../../utils/queryUtils";
import { Loading } from "../../../components/finance/LoadingComponent";
import SimpleHeader from "../../../components/finance/SimpleHeader";
import { useFetchUserInfoQuery } from "../../../api/infoApi";
import LoadingSpinner from "../../../components/LoadingSpinner";

const OfferManagement: React.FC = () => {
  const columns: GridColDef[] = [
    { field: "supplierName", headerName: "Tedarikçi İsmi", width: 130 },
    { field: "advancePaymentPercentage", headerName: "Avans ödemesi %", width: 200, align: "center", headerAlign: "center" },
    { field: "advancePaymentAmount", headerName: "Peşin Ödeme Tutarı", width: 200, align: "center", headerAlign: "center" },
    { field: "advancePaymentMaturity", headerName: "Peşin Ödeme Vadesi", width: 200, align: "center", headerAlign: "center" },
    { field: "expenseAmount", headerName: "Gider Tutarı", width: 150, align: "center", headerAlign: "center" },
    { field: "remainingPaymentAmount", headerName: "Kalan Ödeme Tutarı", width: 200, align: "center", headerAlign: "center" },
    { field: "remainingPaymentMaturity", headerName: "Kalan Ödeme Vadesi", width: 230, align: "center", headerAlign: "center" },
    { field: "requestedAmount", headerName: "Talep Edilen Miktar", width: 180, align: "center", headerAlign: "center" },
    { field: "offeredAmount", headerName: "Teklif Edilen Tutar", width: 150, align: "center", headerAlign: "center" },
    { field: "status", headerName: "Durum", width: 130, align: "center", headerAlign: "center" },
    {
      field: "dueDate",
      headerName: "Bitiş Tarihi",
      width: 200,
      align: "center",
      headerAlign: "center",
      valueGetter: (params: any) => new Date(params.value as string).toLocaleDateString(),
    },
    {
      field: "offeredAt",
      headerName: "Teklif Tarihi",
      width: 200,
      align: "center",
      headerAlign: "center",
      valueGetter: (params: any) => new Date(params.value as string).toLocaleDateString(),
    },
  ];

  const [offers, setOffers] = useState<ITableOffer[]>([]);
  const [paginationModel, setPaginationModel] = useState<IPagination>(defaultPaginationModel);
  const { isLoading: isUserInfoFetchLoading, data: userDetails, refetch: refetchUserDetails } = useFetchUserInfoQuery();
  const [financeId, setFinanceId] = useState<string>("");
  const [queryParams, setQueryParams] = useState<MIQuerySearchParams>({ pageInfo: paginationModel, id: "1" });

  const { data, isSuccess, isFetching, refetch } = useGetAllOffersForFinanceQuery(queryParams);

  useEffect(() => {
    let financeId = sessionStorage.getItem("financeId");
    if (financeId !== null) setFinanceId(financeId);
  }, []);

  useEffect(() => {
    if (financeId) {
      setQueryParams({ pageInfo: paginationModel, id: financeId });
      refetch();
    }
  }, [financeId, paginationModel, refetch]);

  useEffect(() => {
    refetchUserDetails();
  }, [refetchUserDetails]);

  useEffect(() => {
    if (isSuccess && data) {
      const tableStructure: ITableOffer[] = data.map((offer: any) => ({
        id: offer.id,
        supplierName: offer.supplier_name,
        advancePaymentPercentage: offer.advance_payment_percentage,
        advancePaymentAmount: parseFloat(offer.advance_payment_amount.toString()),
        advancePaymentMaturity: offer.advance_payment_maturity,
        expenseAmount: parseFloat(offer.expense_amount.toString()),
        remainingPaymentAmount: parseFloat(offer.remaining_payment_amount.toString()),
        remainingPaymentMaturity: offer.remaining_payment_maturity,
        requestedAmount: offer.requestedTotalAmount,
        offeredAmount: offer.offeredTotalAmount,
        status: offer.status,
        offeredAt: offer.createdAt,
        dueDate: offer.valid_until,
      }));
      setOffers(tableStructure);
    }
  }, [data, isSuccess]);

  return (
    <Box>
      <Grid container>
        <Grid item sm={12}>
          <SimpleHeader title="Teklifler" />
          {isUserInfoFetchLoading && <LoadingSpinner />}
          {isFetching && <Loading />}
          <MTable rows={offers} columns={columns} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default OfferManagement;
